import merge from 'lodash/merge';

const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addPerks: ({ commit }, perks) => perks.forEach(pkg => commit('add', pkg))
};

const mutations = {
  add: (state, perk) => {
    if (!state.allIds.includes(perk.id)) {
      state.byId[perk.id] = perk;
      state.allIds.push(perk.id);
    } else {
      state.byId[perk.id] = merge(state.byId[perk.id], perk);
    }
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
